<input [(ngModel)]="etaTime" [ngxTimepicker]="picker"  [min]="min" [max]="max" [format]="24" class="preorder-time" readonly>
<ngx-material-timepicker #picker [minutesGap]="5" (timeSet)="updateTime($event)"></ngx-material-timepicker>